import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Button, ButtonType } from '@nhl/nhl-breakaway-ui';

import { filterActionCreators } from '~/redux/ducks/playersAndTeams/filter';
import advancedDefaults from '~/redux/ducks/playersAndTeams/filter/values/defaults';
import { reportActionCreators } from '~/redux/ducks/playersAndTeams/report';
import { commonMessages } from '~/utility/commonMessages';

import { compareFilterValues } from '../../filters/utils';

const ClearFilterButton = () => {
    const dispatch = useDispatch();
    const advancedFilters = useSelector((state) => state.playersAndTeams.filter.values);
    const advancedFiltersChanged = compareFilterValues(advancedDefaults, advancedFilters);

    const clickHandler = () => {
        dispatch(filterActionCreators.resetAllFilters());
        dispatch(reportActionCreators.runReport());
    };

    return (
        <Button type="submit" variant={ButtonType.CTA} onClick={clickHandler} disabled={!advancedFiltersChanged}>
            <FormattedMessage {...commonMessages.labels.clearFilters} />
        </Button>
    );
};

// TODO do we want to leave this memo???
export default React.memo(ClearFilterButton);
